/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright (c) 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./inputText.module.scss";
import Icon from "../Icon";
class InputText extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      errorMessage: "",
    };
  }

  errorStateUpdate = () => {
    this.setState({
      errorMessage: this.props.errorMessage,
      error: !(this.state.error && this.props.errorMessage === ""),
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.errorMessage !== this.props.errorMessage) {
      this.errorStateUpdate();
    }
  }

  handleChange = (event) => {
    this.props.getInputTextValue(event.target.value);

    if (this.props.inputTextValidation) {
      this.props.inputTextValidation(event.target.value);
    }
  };

  render() {
    let style_list=[]
    if(this.props.isDisabled){
      style_list = styles.lsDisabled
    }else if(this.props.readOnly){
      style_list = [...style_list, styles.lsReadOnly]
    }else if(this.state.error){
      style_list = [...style_list, styles.lsErrorInputText]
    }
    return (
      <div className={styles.InputTextContainer}>
        {this.props.label != null && (
          <label htmlFor={this.props.id} className={styles.lsLabel}>
            {this.props.label}
          </label>
        )}

        <input
          id={this.props.id}
          style={{ width: this.props.width }}
          className={`${styles.lsInputText}  ${style_list}`}
          onChange={(event) => {
            this.handleChange(event);
          }}
          defaultValue={this.props.defaultValue}
          value={this.props.value}
          readOnly={this.props.readOnly}
          disabled={this.props.isDisabled}
          placeholder={this.props.placeholder}
          aria-label={this.props.ariaLabelHidden ? null : this.props.label }
        />
        {this.props.infoText && (
          <div className={styles.lsInfoText}>{this.props.infoText}</div>
        )}
        {this.state.error && (
          <p 
            className={styles.lsErrorMessage}
            role="alert"
          >
            <span>
              <Icon
                fileName="warning-16"
                name={this.props.id + "-error"}
                title="Error"
                isHidden={true}
              />
              <label>{this.state.errorMessage}</label>
            </span>
          </p>
        )}
      </div>
    );
  }
}

InputText.propTypes = {
  errorMessage: PropTypes.string,
  getInputTextValue: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  infoText: PropTypes.string,
  inputTextValidation: PropTypes.func,
  isDisabled: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.any,
  value: PropTypes.any,
  readOnly: PropTypes.bool,
  width: PropTypes.string,
  ariaLabelHidden: PropTypes.bool
};

InputText.defaultProps = {
  width: "300px",
  isDisabled: false,
  readOnly: false,
  placeholder: "",
  errorMessage: "",
  value: undefined,
  ariaLabelHidden: false
};

export default InputText;
